import dispatcher from './actions';

const initialState = {
  teleConsultRevenueLoading: false,
  teleConsultEpisodesLoading: false,
  teleConsultPeakDayOfWeekLoading: false,
  teleConsultPeakHourOfDayLoading: false,
  categories: [],
  locations: [],
  stations: [],
  consents: [],
  tests: [],
  patientInfo: {},
};

const globalReducer = dispatcher(initialState, {
  [dispatcher.saveDataSuccess]: (state, payload) => {
    const { name, value } = payload;
    return {
      ...state,
      [name]: value,
    };
  },
  [dispatcher.showHideLoadingAction]: (state, payload) => {
    const { name, value } = payload;
    return {
      ...state,
      [name]: value,
    };
  },
});

export default globalReducer;
